import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'validator',
    templateUrl: './validator.component.html',
    styleUrls: ['./validator.component.scss'],
})
export class ValidatorComponent implements OnInit {
    @Input() control: UntypedFormControl;
    @Input() name: string;
    @Input() optionalInput: string = null;
    @Input() topOffset: number = 15;
    @Input() bottomOffset: number = 0;
    @Input() rightOffset: number = 0;
    @Input() leftOffset: number = 0;
    @Input() showOnTouch: boolean = false;
    @Input() errorMessageStyle = 'error-message';

    constructor() {}

    ngOnInit() {}
}
